module.exports = {
	"de": {
		"tabs.info.title": "Meine Leistung",
		"tabs.next_games.title": "Nächste Spiele",
		"tabs.ranking.title": "Rangliste",
		"tabs.initial.title": "Tippspiel",
		"ranking.ranking_list.text": "Die Rangliste ist noch nicht verfügbar. Schau doch nach dem ersten Spiel am 21.09.2018 wieder vorbei.",
		"ranking.ranking_list_item.points": "Punkte",
		"ranking.user_ranking.position": "Platz",
		"ranking.user_ranking.points": "Punkte",
		"ranking.user_ranking.votes": "Tipps",
		"ranking.user_ranking.quote": "Trefferquote",
		"ranking.user_ranking.info.title": "Spielregeln",
		"ranking.user_ranking.info.block1": "Herzlich Willkommen beim HockeyInfo Tippspiel. Du kannst für alle Spiele der National League auf den Gewinner tippen. Für jeden richtigen Tipp erhältst du einen Punkt gutgeschrieben. Das Spiel läuft während der ganzen Qualifikationsphase. Viel Glück!",
		"ranking.user_ranking.info.block2": "* Durch deine Teilnahme erklärst du dich damit einverstanden, dass wir deinen Namen sowie dein Facebook-Profilbild auf der Rangliste publizieren dürfen.",
		"login.facebook": "Mit Facebook anmelden",
		"ad_block.locale": "de"
	},
	"fr": {
		"tabs.info.title": "Ma performance",
		"tabs.next_games.title": "Prochains jeux",
		"tabs.ranking.title": "Classement",
		"tabs.initial.title": "Jeu de paris",
		"ranking.ranking_list.text": "Le classement n'est pas encore disponible. Consultez-le après les premiers matchs qui auront lieu le 21.09.2018.",
		"ranking.ranking_list_item.points": "Points",
		"ranking.user_ranking.position": "Place",
		"ranking.user_ranking.points": "Points",
		"ranking.user_ranking.votes": "Paris",
		"ranking.user_ranking.quote": "Taux de réussite",
		"ranking.user_ranking.info.title": "Règles du jeu",
		"ranking.user_ranking.info.block1": "Bienvenue dans le jeu de paris de HockeyInfo. Vous pouvez parier sur tous les matchs de la National League. Pour chaque pari correct, vous obtenez un point. Le jeu se déroule pendant toute la saison régulière. Bonne chance !",
		"ranking.user_ranking.info.block2": "* En participant, vous acceptez que votre nom ainsi que votre profil Facebook soient affichés dans le classement.",
		"login.facebook": "Continuer avec Facebook",
		"ad_block.locale": "fr"
	},
	"it": {
		"tabs.info.title": "Le mie prestazioni",
		"tabs.next_games.title": "Prossimi giochi",
		"tabs.ranking.title": "Classifica",
		"tabs.initial.title": "Gioco a pronostici",
		"ranking.ranking_list.text": "La classifica non è ancora disponibile. Torna a controllare dopo la prima partita, che si terrà il 21.09.2018.",
		"ranking.ranking_list_item.points": "Punti",
		"ranking.user_ranking.position": "Posizione",
		"ranking.user_ranking.points": "Punti",
		"ranking.user_ranking.votes": "Pronostici",
		"ranking.user_ranking.quote": "Pronostici azzeccati (in %)",
		"ranking.user_ranking.info.title": "Regole del gioco",
		"ranking.user_ranking.info.block1": "Benvenuto al gioco a pronostici di HockeyInfo. Per tutte le partite della Lega Nazionale, puoi scommettere quale sarà la squadra vincitrice. Per ogni pronostico azzeccato incasserai punto. Questo gioco si svolge durante l’intero girone di qualificazione. In bocca al lupo!",
		"ranking.user_ranking.info.block2": "* Partecipando, dichiari di acconsentire alla pubblicazione del tuo nome e della foto del tuo profilo Facebook sulla nostra classifica.",
		"login.facebook": "Continua con Facebook",
		"ad_block.locale": "it"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/data.json
// module id = 519
// module chunks = 0